var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 34,
    stroke: "#243677",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4047 29.5977C43.9508 29.5977 46.3926 30.6091 48.1929 32.4094C49.9933 34.2098 51.0047 36.6516 51.0047 39.1977V50.3977H44.6047V39.1977C44.6047 38.349 44.2675 37.535 43.6674 36.9349C43.0673 36.3348 42.2534 35.9977 41.4047 35.9977C40.556 35.9977 39.7421 36.3348 39.1419 36.9349C38.5418 37.535 38.2047 38.349 38.2047 39.1977V50.3977H31.8047V39.1977C31.8047 36.6516 32.8161 34.2098 34.6165 32.4094C36.4168 30.6091 38.8586 29.5977 41.4047 29.5977Z",
    stroke: "#243677",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4 31.1992H19V50.3992H25.4V31.1992Z",
    stroke: "#243677",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 26.4C23.9673 26.4 25.4 24.9673 25.4 23.2C25.4 21.4327 23.9673 20 22.2 20C20.4327 20 19 21.4327 19 23.2C19 24.9673 20.4327 26.4 22.2 26.4Z",
    stroke: "#243677",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.26d8f02e28d69906d5bbabc1b9209f85.svg";
export { ForwardRef as ReactComponent };